<nz-steps [nzCurrent]="current">
  <nz-step nzTitle="Persona"></nz-step>
  <nz-step nzTitle="Campo"></nz-step>
  <nz-step nzTitle="Horario"></nz-step>
</nz-steps>
<div class="steps-content">
  <div *ngIf="current === 0">
    <app-step-1 (personaSeleccionadaEvent)="handlePersonaSeleccionada()"></app-step-1>
  </div>
  <div *ngIf="current === 1">
    <app-step-2 (stepCompleted)="handleStep2Completion($event)"></app-step-2>
  </div>
  <div *ngIf="current === 2">
    <app-step-3 [step2Data]="step2Data" (stepCompleted)="handleStep3Completion()"></app-step-3>
  </div>
</div>
<div class="steps-action">
  <button nz-button nzType="default" (click)="pre()" *ngIf="current > 0">
    <span>Anterior</span>
  </button>
</div>
